const messages = {
    scanWithBankApp: "امسح باستخدام تطبيق البنك الخاص بك",
    scanWithCreditCardApp: "امسح باستخدام تطبيق بطاقة الائتمان",
    scanOrOpenApp: "امسح أو افتح التطبيق لإتمام الدفع",
    scanForPayment: "امسح للدفع",
    scanWithBankApp: 'امسح بتطبيق البنك للدفع',
    changePaymentWarning: "عند تغيير طريقة الدفع، لن يعمل QR Code السابق. يرجى استخدام الطريقة الجديدة فقط.",
    swapShop: "هل تريد التبديل إلى<br>المتجر الجديد؟",
    swapShopDespt: "سيتم حفظ العناصر المختارة من المتجر السابق ويمكن طلبها لاحقاً",
    sorryForInconvenient: 'نعتذر عن الإزعاج',
    openAt: 'يفتح في',
    shopIsClosedToday: 'المتجر مغلق اليوم',
    checkOrderedItem: 'تحقق من الأطعمة المطلوبة',
    tryAgainIn: 'أعد المحاولة في',
    lockUserPIN: "لقد أدخلت PIN خاطئ أكثر من 5 مرات",
    lockUserPINDespt: "أعد المحاولة بعد 5 دقائق",
    inValidPIN: 'PIN غير صحيح',
    enterPasswordToAccessMenu: "أدخل PIN للوصول إلى القائمة",
    customersCanGetPasswordFromStaff: "يمكن للعملاء الحصول على PIN من الموظفين",
    tableNotAvailable: "الطاولة غير متاحة",
    contactStaffToOpenTable: "تواصل مع الموظف لفتح الطاولة",
    outOfRestaurantRange: "خارج نطاق المطعم",
    phoneIsMoreThan100MetersAwayFromRestaurant: "هاتفك على بعد أكثر من 100 متر من المطعم",
    restaurantIsCurrentlyClosed: "المطعم مغلق حالياً",
    restaurantOpenHours: "المطبخ مفتوح من",
    packingSize: 'حجم العبوة',
    shippingDelivery: 'الشحن',
    waitForPaymentDelivery: 'بانتظار الدفع',
    readyForPcikup: 'جاهز للاستلام',
    noNotifyNow: "لا توجد إشعارات حالياً",
    noNotifyNowDespt: "عند بدء استخدام الخدمة، ستظهر إشعاراتك هنا",
    newAddressDespt: "لتسهيل التوصيل، يرجى تحديد الوجهة الصحيحة والسماح بالوصول إلى موقعك",
    deleteAddressSuccess: 'تم حذف العنوان بنجاح',
    createProfileSuccess: "تم إنشاء الملف الشخصي بنجاح",
    ex: 'مثال',
    receiverName: 'اسم المستلم',
    editAddress: 'تعديل العنوان',
    nameInputInvalid: 'اسم غير صحيح',
    openInGoogleMap: 'افتح في Google Map',
    pleaseSelectPaymentMethod: 'يرجى اختيار طريقة الدفع',
    noDeliveryAddress: 'لا يوجد عنوان توصيل',
    noDeliveryAddressDespt: 'يرجى إضافة معلومات عنوان التوصيل',
    deliveryType: 'توصيل',
    pickupType: 'استلام',
    shopIsClose: 'المتجر مغلق',
    openingHoursDespt: 'ساعات العمل',
    contactShop: 'تواصل مع المتجر',
    pickupAtShop: 'استلام',
    thanksForOrderingDespt: 'شكراً لطفك.<br>نأمل أن نراك مجدداً!',
    deliveredSuccess: 'تم التوصيل',
    expireIn: 'ينتهي خلال',
    waitForPayment: 'بانتظار الدفع',
    waitForPaymentDespt: "يرجى انتظار تأكيد الدفع من النظام.<br>إذا لم تقم بالدفع بعد، يرجى إتمام الدفع خلال الوقت المحدد لتجنب إلغاء الطلب.",
    newOrderIn: 'جديد',
    inputRequestDetails: 'حدد تفاصيل الطلب',
    notification: 'الإشعارات',
    noticeIfOrderReady: 'سنخبرك عندما يكون طلبك جاهزاً للاستلام',
    orderIsReady: 'طلبك جاهز للاستلام',
    thanksForOrdering: 'شكراً لاستخدام خدمتنا',
    toPay: 'للدفع',
    letOrder: 'انتقل إلى صفحة القائمة وابدأ الطلب الآن',
    noTransaction: 'لا توجد معاملات',
    menulists: 'قوائم الطعام',
    editPersonalDetails: 'تعديل التفاصيل',
    trackOrder: 'تتبع الطلب',
    myAccount: 'حسابي',
    cart: 'السلة',
    helpCenter: 'مركز المساعدة',
    allPurchaseHistory: 'سجل المشتريات',
    purchaseHistory: 'سجل المشتريات',
    personalInfo: 'البيانات الشخصية',
    cutlery: 'أدوات المائدة',
    km: 'كم',
    totalAmountSum: 'المجموع',
    selectedItemList: 'العناصر المختارة',
    iAm: 'أنا',
    orderedBy: 'طلب بواسطة',
    shareQRtoFriend: 'مشاركة QR Code',
    share: 'مشاركة',
    hasItemInBasket: 'توجد عناصر في السلة',
    hasItemInBasketDespt: 'لا تنسَ إرسالها إلى المطبخ',
    updatedAtQR: 'تم التحديث في',
    orderSent: 'تم إرسال الطلب إلى المطبخ',
    orderSentDespt: 'المطعم يجهز طعامك',
    checkGramdTotalIn: 'يمكنك التحقق من المبلغ الإجمالي في',
    vatNotInclude: 'هذا السعر لا يشمل الضرائب ورسوم الخدمة والخصومات',
    accept: 'موافق',
    termOfService: 'شروط الخدمة',
    onPending: 'قيد الانتظار',
    OnSuccessOrder: 'ناجح',
    prepareingOrder: 'جارٍ تحضير الطلب',
    deliveringOrder: 'جارٍ توصيل الطلب',
    pickupOrderReady: 'جاهز للاستلام',
    pickedupOrder: 'تم الاستلام',
    deliveredOrder: 'تم توصيل الطلب',
    shopReceivedOrder: 'المتجر استلم الطلب',
    orderId: 'رقم الطلب',
    orderDetails: 'تفاصيل الطلب',
    deliveryFee: 'رسوم التوصيل',
    searchDriver: 'جارٍ البحث عن سائق',
    driverFrom: 'السائق من',
    change: 'تغيير',
    deliveryAddress: 'عنوان التوصيل',
    location: 'الموقع',
    addressName: 'اسم العنوان',
    addressNameDespt: 'مثال: اسم الشقة، اسم الحي',
    addressDescription: 'تفاصيل العنوان',
    addressDescriptionDespt: 'مثال: رقم المبنى، الزقاق',
    noteToDriver: 'ملاحظة للسائق',
    noteToDriverDespt: 'مثال: ضعه على الطاولة عند المدخل',
    inputAddressForm: 'أدخل عنوان التوصيل',
    plsPinAddress: 'حدد موقعك',
    pinLocation: 'حدد موقع التوصيل',
    createNewAddress: 'إنشاء عنوان جديد',
    savedAddress: 'العناوين المحفوظة',
    phoneNumber: 'رقم الهاتف',
    noRequired: 'اختياري',
    resendCode: 'إعادة إرسال الرمز',
    didNotGetCode: 'لم تحصل على الرمز؟',
    resendIn: 'إعادة الإرسال خلال',
    next: 'التالي',
    createAccount: 'إنشاء حساب',
    createAccountDespt: 'املأ النموذج أدناه لإنشاء حساب للمتابعة',
    sendCodeViaSMS: 'إرسال الرمز عبر SMS',
    inputOTP: 'أدخل OTP',
    inputOTPDespt: 'يرجى إدخال الرمز المكون من 6 أرقام المرسل إلى',
    termAndPolicy: 'الشروط والسياسة',
    termAndPolicy1: 'باستخدام خدمتنا، فإنك توافق على',
    termAndPolicy2: 'انقر لقراءة اتفاقية الشروط والسياسة كاملة',

    loginWithPhoneNumber: 'تسجيل الدخول برقم الهاتف',
    loginWithPhoneNumberDespt: 'أدخل رقم هاتفك لتلقي OTP للتحقق من الهوية',
    backToOrder: 'العودة إلى القائمة',
    PaymentMethod: 'الدفع',
    paymentAmount: 'مبلغ الدفع',
    paymentConfirmation: 'تأكيد الدفع',
    cancelPayment: 'إلغاء الدفع',
    paidSuccess: 'تم الدفع',
    haveNotPurchased: 'لم يتم الشراء بعد',
    haveNotPurchased2: 'في حالة فشل الدفع، يرجى التواصل مع الموظف',
    canNotOrderItem: 'لا يمكنك طلب الطعام أثناء الدفع',
    checkPaymentStatus: 'تحقق من الحالة',
    pendingPayment: 'الدفع معلق',
    askForReceipt: 'إذا كنت بحاجة إلى إيصال، يرجى التواصل مع الموظف',
    paymentSuccess: 'الدفع ناجح',
    summaryPayment: 'الملخص',
    numberOfGuest: 'عدد الضيوف',
    closeTab: 'إغلاق',
    addCredit: 'إضافة بطاقة ائتمان',
    QRPayment: 'دفع QR',
    cardPayment: 'بطاقة ائتمان',
    payWithStaff: 'الدفع عند الكاشير',
    selectPaymentMethod: 'اختر طريقة الدفع',
    checkOut: 'الدفع',
    startOrderBeforeCallStaff: 'يرجى طلب الطعام قبل استدعاء الموظف',
    basket: 'السلة',
    spoon: 'طلب أدوات مائدة',
    knife: 'طلب سكين',
    chopstick: 'طلب عيدان',
    cup: 'طلب كوب',
    plate: 'طلب طبق',
    glass: 'طلب كأس',
    payBill: 'طلب الفاتورة',
    viewAll: 'عرض الكل',
    recommendMenu: 'مُوصى به',
    OnSuccess: 'ناجح',
    OnPreparing: 'قيد التحضير',
    messageSent: 'يرجى انتظار موظفنا',
    outOfStock: 'نفد المخزون',
    QRCode: 'QR Code',
    GenerateQRCode: 'إنشاء QR Code',
    ForQROrder: 'لطلب الطعام وطلب الخدمة داخل المتجر',
    QROrderDescription: 'يمكنك إنشاء QR Code للعملاء لمسحه لطلب الطعام وطلب الخدمة داخل المتجر',
    SelectTable: 'اختر طاولة وأدخل عدد الضيوف.',
    shopname: 'اسم المتجر',
    numberOfCustomer: 'عدد العملاء (أشخاص)',
    numberOfCustomerDescription: 'أدخل عدد العملاء، الحد الأدنى شخص واحد',
    currentUser: 'المستخدم',
    guest: 'الضيوف',
    orderItem: 'ملخص الطلب',
    orderItemNav: 'ملخص الطلب',
    callStaff: 'استدعاء الموظف',
    callStaffDialog: 'ما نوع المساعدة التي تحتاجها؟',
    cutlery: 'طلب أدوات مائدة',
    seasoning: 'طلب توابل',
    refillDrink: 'طلب إعادة تعبئة المشروب',
    other: 'أخرى',
    tableNumber: 'الطاولة',
    menuList: 'القائمة',
    selectedItem: 'طلب الطعام',
    selectedItemNav: 'طلب الطعام',
    checkOrderBeforeConfirm: 'يرجى التحقق من تفاصيل طلبك والمجموع قبل إرساله إلى المطعم',
    checkOrderBeforeConfirm2: '',
    startOrder: 'ابدأ الطلب',
    foodCategory: 'الفئة',
    searchByName: 'البحث عن المنتج بالاسم...',
    noPreduct: 'لا يوجد منتج متاح',
    noSelectedProduct: 'لا يوجد عنصر مختار',
    noSelectedProductDespt: 'إذا قمت باختيار منتجات، ستظهر قائمة اختياراتك في هذه الصفحة',
    backToMenu: 'الذهاب إلى القائمة',
    removeSelected: 'هل تريد حذف هذا العنصر؟',
    confirmOrder: 'إرسال الطلب',
    endOfTransection: 'نهاية المعاملة',
    endOfTransectionDialog: 'في حالة وجود مشاكل، يرجى التواصل مع الموظف',
    note: 'ملاحظة',
    orderTime: 'وقت الطلب',
    orderMoreFood: 'العودة إلى القائمة الرئيسية',
    orderPreparing: 'طهاتنا يجهزون وجبتك. يرجى الانتظار قليلاً. سيتم تقديم طعامك قريباً',
    orderPreparing2: '',
    sendingOrder: 'جارٍ إرسال طلبك إلى المطبخ...',
    login: 'تسجيل الدخول',
    forgetPassword: 'نسيت كلمة المرور?',
    loginWithGmail: 'تسجيل الدخول بـ Gmail',
    or: 'أو',
    loginAsStaff: 'تسجيل الدخول كموظف',
    billOrder: 'الفاتورة',
    table: 'الطاولة',
    billOrderDialog: 'امسح QR Code لعرض القائمة والطلب',
    billOrderDialog2: 'في حالة وجود مشاكل، يرجى التواصل مع الموظف',
    selectTableAleart: 'يرجى اختيار طاولة قبل إنشاء QR Code',
    emptyCartDialog: 'لا توجد معاملات',
    emptyCartDialogDespt: 'إذا أكدت الطلب، ستظهر قائمة العناصر المطلوبة في هذه الصفحة',
    served: 'تم التقديم',
    contactOurStaff: 'تواصل مع موظفنا',
    contactOurStaff2: 'في حالة طلب المساعدة',
    addToCart: 'أضف إلى السلة',
    noteToShop: 'ملاحظة للمتجر',
    addYourRequest: 'أضف طلبك',
    branchName: 'اسم الفرع',
    businessType: 'نوع العمل',
    taxID: 'الرقم الضريبي',
    vat: 'الضريبة',
    exclusive: 'غير شامل الضريبة',
    inclusive: 'شامل الضريبة',
    serviceCharge: 'رسوم الخدمة',
    address: 'العنوان',
    address1: 'سطر العنوان 1',
    address2: 'سطر العنوان 2',
    tel: 'هاتف',
    businessType1: 'عام',
    businessType2: 'مطعم',
    businessType3: 'نزل',
    shopopen: 'مفتوح - مغلق',
    open: 'مفتوح',
    closed: 'مغلق',
    languagetxt: 'اللغة',
    language: 'اللغة والمنطقة الزمنية',
    languageTH: 'تايلاندي',
    languageEN: 'إنجليزي',
    setting: 'الإعدادات',
    shop: 'المتجر',
    timezone: 'المنطقة الزمنية',
    deliveryProviders: 'مزودو التوصيل',
    adddeliveryProviders: 'إضافة مزود',
    lastUpdate: 'آخر تحديث',
    logo: 'الشعار',
    updateData: 'تحديث البيانات',
    submit: 'إرسال',
    cancel: 'إلغاء',
    normal: 'عادي',
    loading: 'جارٍ التحميل...',
    editing: 'تعديل',
    confirmUpdate: 'هل تريد تحديث البيانات؟',
    selectedShoptype: 'اختر نوع العمل...',
    selectshop: 'اختر اسم الفرع',
    save: 'حفظ',
    reporttxt: 'التقارير',
    general: 'عام',
    signOut: 'تسجيل الخروج',
    registration: '',
    unit: 'الوحدة',
    category: 'الفئة',
    product: 'المنتج',
    export: 'تصدير',
    exportKBank: 'تصدير K-Bank',
    date: 'التاريخ',
    to: 'إلى',
    status: 'الحالة',
    vatAmount: 'الضريبة',
    netTotalNonVAT: 'الإجمالي (بدون ضريبة)',
    receiptNumber: 'رقم الإيصال',
    grandTotal: 'المجموع الكلي',
    netAmountVATTotal: 'المجموع الفرعي',
    netTotalIncVAT: 'الإجمالي (شامل الضريبة)',
    proofOfPayment: 'إثبات الدفع',
    paymentType: 'نوع الدفع',
    paymentType0: 'نقداً',
    paymentType1: 'بطاقة ائتمان',
    paymentType2: 'قسيمة',
    paymentType3: 'Quickpay',
    paymentType4: 'Promptpay',
    paymentType5: 'Alipay',
    paymentType6: 'إيداع',
    paymentType7: 'توصيل',
    paymentType8: 'إلكتروني',
    paymentType9: 'Line Pay',
    paymentType10: 'دفع مخصص',
    paymentType12: 'KBank',
    paid: 'قيمة الدفع',
    sentSuccessfully: 'تم الإرسال بنجاح',
    pluCode: 'باركود',
    netAmount: 'الصافي',
    discount: 'خصم',
    timeOfOrder: 'وقت الطلب',
    orderDate: 'تاريخ الطلب',
    preparing: 'قيد التحضير',
    paymentDetail: 'تفاصيل الدفع',
    orderNumber: 'رقم الطلب',
    delivered: 'تاريخ الاستحقاق',
    deliveredDate: 'مدة التسليم',
    payment: 'الدفع',
    productName: 'اسم المنتج',
    quantity: 'الكمية',
    priceUnit: 'السعر/الوحدة',
    baht: 'بات',
    profit: 'الربح',
    sales: 'المبيعات',
    billAmount: 'إجمالي الفاتورة',
    total: 'المجموع',
    bill: 'الفاتورة',
    discountAmount: 'مبلغ الخصم',
    averageBill: 'المتوسط/فاتورة',
    voidbillTotal: 'إجمالي الفواتير الملغاة',
    salesByDaily: 'المبيعات اليومية',
    salesByMonth: 'المبيعات الشهرية',
    bestSellers: 'الأكثر مبيعاً',
    bestSellerstype: 'فئة الأكثر مبيعاً',
    salesBydate: 'المبيعات حسب التاريخ',
    number: 'رقم',
    categoryName: 'اسم الفئة',
    newOrder: 'طلب مرسل',
    reject: 'رفض',
    inProgressTime: 'وقت المعالجة',
    rejectTime: 'وقت الرفض',
    cancelTime: 'وقت الإلغاء',
    cause: 'السبب',
    preparingToShip: 'قيد التحضير',
    totalAmount: 'المجموع',
    order: 'الطلب',
    deposit: 'إيداع',
    billSave: 'حفظ',
    ReceivingOrder: 'فتح الطاولة/استلام الطلب',
    orderNo: 'رقم الطلب',
    remark: 'ملاحظة',
    receiptStatus: 'حالة الإيصال',
    back: 'رجوع',
    detail: 'التفاصيل',
    countSales: 'الكمية',
    onhandQty: 'الرصيد',
    stdCost: 'التكلفة',
    employees: 'الموظفون',
    employeesname: 'اسم الموظف',
    salesTotal: 'إجمالي المبيعات',
    totalBill: 'عدد جميع الفواتير',
    billActive: 'عدد فواتير البيع',
    billVoice: 'عدد الفواتير الملغاة',
    billDeposit: 'عدد فواتير الإيداع',
    discountItem: 'إجمالي خصم العناصر',
    billDiscountAmount: 'إجمالي خصم الفواتير',
    billDiscount: 'عدد فواتير الخصم',
    payTotal: 'إجمالي المدفوعات',
    deliveryProvider: 'مزود التوصيل',
    deliveryDetail: 'تفاصيل التوصيل',
    customDetail: 'تفاصيل الدفع المخصص',
    customPaymentName: 'اسم الدفع المخصص',
    firstInvoiceNO: 'رقم أول فاتورة',
    lastInvoiceNO: 'رقم آخر فاتورة',
    roundNo: 'رقم الجولة',
    closeAt: 'أُغلق في',
    closeBy: 'أُغلق بواسطة',
    totalCashSales: 'إجمالي المبيعات النقدية',
    initialChange: 'الصرف الأولي',
    totalCashIn: 'إجمالي النقد الوارد',
    totalCashOut: 'إجمالي النقد الصادر',
    actualInDrawer: 'الفعلي في الدرج',
    expectedInDrawer: 'المتوقع في الدرج',
    difference: 'الفرق',
    voidBillDetail: 'تفاصيل الفاتورة الملغاة',
    cancelBy: 'ألغي بواسطة',
    cancelDate: 'تاريخ الإلغاء',
    searchByEmployees: 'البحث حسب الموظف',
    search: 'بحث',
    timeIn: 'وقت الحضور',
    timeOut: 'وقت الانصراف',
    time: 'الوقت',
    hours: 'ساعات',
    seconds: 'ثوانٍ',
    netTotal: 'المجموع',
    reason: 'السبب',
    searchByProduct: 'البحث حسب المنتج',
    sortBy: 'ترتيب حسب',
    last: 'الأحدث',
    price: 'سعر المنتج',
    sortByNumMin: 'أقل سعر',
    sortByNumMax: 'أعلى سعر',
    documentNo: 'رقم المستند',
    transactionType: 'نوع المعاملة',
    updatedBy: 'حُدّث بواسطة',
    transactionType1: 'بيع',
    transactionType2: 'استرداد',
    transactionType3: 'إدخال مخزون',
    transactionType4: 'إخراج مخزون',
    transactionType5: 'تعديل إدخال مخزون',
    transactionType6: 'تعديل إخراج مخزون',
    transactionType7: 'استبدال نقاط',
    transactionType8: 'حذف إدخال مخزون',
    transactionType9: 'حذف إخراج مخزون',
    transactionType10: 'تعديل إدخال مخزون',
    transactionType11: 'تعديل إخراج مخزون',
    billNo: 'رقم الفاتورة',
    docTotal: 'المجموع',
    customer: 'العميل',
    username: 'اسم المستخدم',
    dateOfBill: 'تاريخ الفاتورة',
    selectDate: 'اختر التاريخ',
    dialogSelectCategory: 'يرجى اختيار الفئة للبحث',
    dialogUpdateDocumentSuccess: 'تم تحديث المستند بنجاح',
    dialogfound: 'المعلومات المدخلة غير صحيحة.',
    isVatIncluded: 'هل تشمل الضريبة',
    vatIccludes: 'VAT',
    confirmStock: 'تأكيد المخزون',
    confirm: 'تأكيد',
    deleteDoc: 'حذف المستند',
    confirmUpdateDocModal: 'هل تريد تحديث مستند المخزون؟',
    confirmSaveDoc: 'تأكيد حفظ المستند',
    confirmDeleteDoc: 'تأكيد حذف المستند',
    confirmDeleteModal: 'هل تريد حذف مستند المخزون؟',
    dialogSaveDocumentSuccess: 'تم حفظ المستند بنجاح',
    createStockIn: 'إنشاء إدخال مخزون',
    confirmSaveDocModal: 'هل تريد حفظ مستند المخزون؟',
    selectShopPlease: 'يرجى اختيار المتجر',
    selectProductPlease: 'يرجى اختيار المنتج',
    duplicateProduct: 'لقد اخترت هذا العنصر بالفعل.',
    productInvilid: 'العنصر المختار غير صالح. يرجى التواصل مع مسؤول النظام.',
    confirmStockOut: 'تأكيد إخراج المخزون',
    dialogSaveDocumentOutSuccess: 'تم حفظ المستند بنجاح',
    confirmSaveDocStockOutModal: 'هل تريد حفظ مستند إخراج المخزون؟',
    adjustDocType: 'نوع مستند التعديل',
    adjustDocType1: 'زيادة',
    adjustDocType2: 'تقليل',
    beforeAdjust: 'قبل تعديل المخزون',
    afterAdjust: 'بعد تعديل المخزون',
    adjust: 'تعديل المخزون',
    createDoucument: 'إنشاء مستند',
    transferType: 'نوع النقل',
    transferType1: 'نقل وارد',
    transferType2: 'نقل صادر',
    new: 'جديد',
    finish: 'إنهاء',
    refDocument: 'مستند مرجعي',
    statusDoc: 'حالة المستند',
    dialogSaveTransferDocumentSuccess: 'تم إنشاء مستند النقل بنجاح',
    destinationShop: 'المتجر الوجهة',
    destinationShopBranch: 'الفرع الوجهة',
    sourceBranch: 'الفرع المصدر',
    sourceShop: 'المتجر المصدر',
    sourceAddress: 'عنوان المصدر',
    destinationAddress: 'عنوان الوجهة',
    saveTransfer: 'حفظ نقل المخزون',
    confirmSaveTransfer: 'هل تريد حفظ نقل المخزون؟',
    savinserviceChargegDoc: 'جارٍ حفظ المستند',
    selectdestinationPlease: 'يرجى اختيار الفرع الوجهة',
    validatedestinationproduct: "الفرع الوجهة لا يملك هذا المنتج",
    validateProduct: 'يرجى اختيار المنتج',
    created_by: 'بواسطة',
    receive: 'استلام',
    updateDoc: 'تحديث المستند',
    cancelDoc: 'إلغاء المستند',
    confirmCancelDoc: 'هل تريد إلغاء هذا المستند؟',
    cancelingDoc: 'جارٍ إلغاء المستند',
    updatingDoc: 'جارٍ تحديث المستند',
    updateDocFail: "لا يمكن تحديث المستند",
    cancelDocSuccess: 'تم إلغاء المستند',
    cancelDocFail: "لا يمكن إلغاء المستند",
    refDocumentTransfer: 'مستند مرجعي',
    comfrimTransferIn: 'تأكيد نقل المخزون الوارد',
    dilogcomfrimTransferIn: 'هل تريد نقل المخزون الوارد؟',
    transferInDetail: 'تفاصيل نقل المخزون',
    totalNet: 'الصافي',
    confirmAdjust: 'تأكيد تعديل المخزون',
    createStockOut: 'إنشاء إخراج مخزون',
    favorite: 'المفضلة',
    isOnScreen: 'عرض على الشاشة',
    negotiatePrice: 'التفاوض على السعر',
    productTypeP: 'منتج عام',
    productTypeBOM: 'قائمة المواد',
    productTypeSN: 'منتج مسلسل',
    productTypeSV: 'خدمة (بدون مخزون)',
    productPLU: 'أحجام تغليف أخرى',
    productBOM: 'المواد',
    productSN: 'Serial Number',
    morePrice: 'أسعار أخرى',
    cost: 'التكلفة',
    quantityPrice: 'الكمية',
    exceedUc: 'السعر',
    changeImg: 'تغيير الصورة',
    addProduct: 'إضافة منتج',
    selectImg: 'اختر صورة',
    deleteImg: 'حذف صورة',
    selectImgFromPC: 'اختر صورة من الكمبيوتر',
    confirmSaveImgDialog: 'هل تريد حفظ المنتج؟',
    confirmSaveImg: 'تأكيد حفظ المنتج.',
    addPrice: 'إضافة سعر',
    editPrice: 'تعديل السعر',
    dialigDeleteProduct: 'هل تريد حذف المنتج؟',
    confirmDeleteProduct: 'تأكيد حذف هذا المنتج.',
    productType: 'نوع المنتج',
    countProduct: 'عدد المنتجات',
    addUnit: 'إضافة وحدة',
    editUnit: 'تعديل الوحدة',
    active: 'نشط',
    inactive: 'غير نشط',
    confirmSaveUnitDialog: 'هل تريد حفظ الوحدة؟',
    confirmSaveUnit: 'تأكيد حفظ هذه الوحدة.',
    dialigDeleteUnit: 'هل تريد حذف الوحدة؟',
    confirmDeletUnit: 'تأكيد حذف هذه الوحدة.',
    confirmSaveCategoryDialog: 'هل تريد حفظ الفئة؟',
    confirmSaveCategory: 'تأكيد حفظ هذه الفئة.',
    dialigDeleteCategory: 'هل تريد حذف الفئة؟',
    confirmDeletCategory: 'تأكيد حذف الفئة.',
    addCategory: 'إضافة فئة',
    editCategory: 'تعديل الفئة',
    bgColor: 'لون الخلفية',
    selectbgColor: 'اختر لون الخلفية',
    validateCategoryname: 'يرجى إدخال اسم الفئة.',
    sequence: 'الترتيب',
    enterProduct: 'يرجى إدخال اسم المنتج.',
    enterPrice: 'يرجى إدخال سعر المنتج.',
    selectCategory: 'يرجى اختيار فئة المنتج.',
    selectUnit: 'يرجى اختيار وحدة المنتج.',
    confirmSaveProduct: 'هل تريد حفظ هذا المنتج؟',
    confirmSaveProductPrice: 'هل تريد حفظ السعر الآخر؟',
    validatepackQty: 'يرجى إدخال السعر/الوحدة.',
    validatepackUc: 'يرجى إدخال السعر.',
    validatePRU: 'بيانات مكررة، يرجى الإدخال مرة أخرى.',
    createProductSuccess: 'تم إنشاء المنتج بنجاح',
    addSerial: 'إضافة رقم تسلسلي',
    add: 'إضافة',
    createSerial: 'إنشاء Serial Number',
    available: 'جاهز للبيع',
    soldOut: 'نفد',
    deleteSuccess: 'تم الحذف بنجاح',
    enterSerial: 'يرجى إدخال Serial Number',
    confirmSaveSerial: 'هل تريد حفظ Serial Number هذا؟',
    confirmDelete: 'هل تريد حذف Serial Number هذا؟',
    addProductPLU: 'إضافة حجم تغليف',
    img: 'صورة',
    SKURatio: 'النسبة',
    editProductPLU: 'تعديل حجم التغليف',
    enterSKURatio: 'يرجى إدخال النسبة',
    comfrimDeletePLU: 'هل تريد حذف حجم التغليف هذا؟',
    useStepPrice: 'استخدام السعر التدريجي',
    addBOM: 'إضافة مواد',
    confirmSaveBOM: 'هل تريد حفظ المواد؟',
    user: 'المستخدم',
    userDetail: 'تفاصيل المستخدم',
    planDetail: 'تفاصيل الخطة',
    currentPlan: 'الخطة الحالية',
    expireDate: 'تاريخ الانتهاء',
    startDate: 'تاريخ البدء',
    dialogSignOut: 'هل تريد تسجيل الخروج؟',
    confirmSignOut: 'تأكيد تسجيل الخروج',
    countMember: 'جميع الأعضاء',
    addMenber: 'إضافة عضو',
    searchMember: 'البحث بالاسم والبريد والهاتف',
    dateOfMember: 'تاريخ العضوية',
    recentVisit: 'آخر زيارة',
    memberName: 'اسم العضو',
    email: 'البريد الإلكتروني',
    paymentTotal: 'إجمالي المدفوعات',
    point: 'نقاط',
    pointtxt: 'نقاط',
    postalCode: 'الرمز البريدي',
    saveing: 'جارٍ الحفظ...',
    edit: 'تعديل',
    editMember: 'تعديل العضو',
    deleteing: 'جارٍ الحذف...',
    dialogDeleteMember: 'هل تريد حذف العضو؟',
    confirmDeleteMember: 'تأكيد الحذف',
    valtdateMember: 'يرجى ملء المعلومات',
    createMemberSuccess: 'تمت إضافة العضو بنجاح!',
    updateMemberSuccess: 'تم تعديل العضو بنجاح!',
    deleteMemberSuccess: 'تم حذف العضو بنجاح!',
    onhandQtyMin: 'الحد الأدنى للمخزون',
    onhandQtyMax: 'الحد الأقصى للمخزون',
    onhandQtySort: 'كمية المخزون',
    showProductAll: 'جميع أنواع المنتجات',
    updateAt: 'آخر تحديث',
    sortName: 'الاسم',
    stockUnit: 'التكلفة/الوحدة',
    deleteCategory: 'حذف الفئة',
    selectd: 'اختيار',
    searchProduct: 'البحث عن منتج',
    reset: 'إعادة تعيين',
    selectdProduct: 'اختر المنتج',
    information: 'المعلومات',
    adjustStockList: 'منتجات تعديل المخزون',
    adjustDetail: 'إضافة منتج إلى قائمة تعديل المخزون وإعداده',
    transferoutList: 'منتجات نقل المخزون',
    addProductTransfer: 'إضافة منتج إلى قائمة نقل المخزون وإعداده',
    transferDetail: 'منتج إلى قائمة إخراج المخزون وإعداده',
    transferinList: 'منتج إلى قائمة إدخال المخزون وإعداده',
    stockOutList: 'منتجات إخراج المخزون',
    addstockOutList: 'إضافة منتج إلى قائمة إخراج المخزون وإعداده',
    stockinList: 'منتجات إدخال المخزون',
    addProductStockin: 'إضافة منتج إلى قائمة إدخال المخزون وإعداده',
    checkCount: 'فحص المخزون',
    createAdjustStock: 'إنشاء تعديل مخزون',
    memberDetail: 'معلومات العضو',
    package: 'تفاصيل الباقة',
    startPackate: 'بداية الباقة',
    endPackate: 'نهاية الباقة',
    name: 'الاسم',
    productImg: 'صورة المنتج',
    fistname: 'الاسم الأول',
    lastname: 'اسم العائلة',
    saveMember: 'حفظ المعلومات',
    confirmSaveMember: 'هل تريد حفظ العضو؟',
    yesOrNo: 'نعم أو لا',
    totaValue: 'المجموع',
    deleteMember: 'حذف العضو',
    frequently: 'المنتجات الأكثر شراءً',
    recentPurchase: 'آخر عملية شراء',
    paymentDescription: 'وصف الدفع',
    validateInfomation: 'يرجى إدخال المعلومات',
    validateTel: 'رقم الهاتف غير صحيح',
    validateOTP: 'OTP غير صحيح',
    validateEmail: 'البريد الإلكتروني غير صحيح',
    saveSuccess: 'تم الحفظ بنجاح',
    txtcustomer: 'العميل',
    customerName: 'اسم العميل',
    customerCount: 'عدد العملاء',
    addCustomer: 'إضافة عميل',
    permissionManage: 'الصلاحيات',
    mainMenu: 'القائمة الرئيسية',
    page: 'صفحة',
    show: 'عرض',
    delete: 'حذف',
    administratorTools: 'أدوات المسؤول',
    deviceName: 'اسم الجهاز',
    lastSyncProduct: 'آخر مزامنة',
    version: 'الإصدار',
    posstatus: 'الحالة',
    posNumber: 'رقم POS',
    titleSilomconnect: 'لا تفوت أي مبيعات مع خدمات من',
    updateSilom: 'تحديث المبيعات اليومية عبر LINE مجاناً',
    addfriend: 'إضافة صديق',
    enterToReciveService: 'اضغط لاستلام رمز استخدام الخدمة.',
    verifyCodeToUsed: 'لبدء استخدام النظام، يمكنك الضغط لاستلام رمز التحقق من الهوية.',
    verifyfivemin: 'رمز التحقق صالح لمدة 5 دقائق.',
    yourVertify: 'رمز التحقق الخاص بك هو',
    pressCode: 'اضغط لاستلام الرمز',
    exCode: 'الرمز ينتهي خلال',
    sessionEx: 'انتهت جلسة تسجيل الدخول. يرجى تسجيل الدخول مرة أخرى.',
    refresh: 'تحديث',
    selectedFile: 'اختر ملف',
    fileSize: 'حجم الملف لا يزيد عن 2 ميغابايت.',
    isBeingToUsed: 'قيد الاستخدام',
    notInUse: 'غير مستخدم',
    delete: 'حذف',
    confirmUpdateInformation: 'تأكيد تحديث المعلومات',
    memberCount: 'العدد',
    orderMachine: 'جهاز الطلب',
    textMember: 'عضو',
    manageShop: 'إدارة معلومات المتجر',
    lansetting: 'إعداد لغة ومنطقة زمنية المتجر',
    timezoneSetiing: 'إعداد المنطقة الزمنية للمتجر',
    deliveryProviderSetting: 'مزودو التوصيل للمتجر',
    toolsSetting: 'إدارة أجهزة POS للمتجر',
    checkStockPLU: 'رصيد المنتج < 0',
    searching: 'جارٍ البحث',
    allProduct: 'جميع المنتجات',
    foundProductOnhand: 'تم العثور على منتج برصيد مخزون < 0',
    confirmAdjustBefor: 'هل تريد التعديل التلقائي بواسطة النظام؟',
    requireAdjust: 'نعم',
    imrequireAdjust: 'لا',
    islimitItemTodoc: 'يمكنك اختيار حتى 200 عنصر / مستند واحد.',
    barcodePrint: 'طباعة الباركود',
    printEx: 'طباعة ومثال',
    print: 'طباعة',
    downloadAndExport: 'تنزيل وطباعة',
    selectFormat: 'اختر حجم الورق',
    peperFormat: 'حجم الورق',
    optional: 'اختياري',
    standardA427: 'A4 قياسي: 27 عنصر/صفحة',
    standardA450: 'A4 قياسي: 52 عنصر/صفحة',
    standardA460: 'A4 قياسي: 60 عنصر/صفحة',
    standardA556: 'A4 قياسي: 56 عنصر/صفحة (حجم الملصق: A5)',
    standardA550: 'ورق A5: 52 عنصر/صفحة',
    standardA560: 'ورق A5: 60 عنصر/صفحة',
    countBarcode: 'عدد الباركود',
    barcode: 'باركود',
    setFontsize: 'إعداد الخط',
    accessPermissionDes: 'تعيين صلاحيات الوصول للمستخدمين.',
    deleteUser: 'تأكيد حذف المستخدم',
    confirmDeleteUser: 'هل تريد حذف المستخدم؟',
    passAtless: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل.',
    inValidPass: 'كلمة مرور غير صحيحة',
    createBy: 'أُنشئ بواسطة',
    adjustAutoDes: "إذا كنت لا تريد التحديث التلقائي من النظام، قد يكون رصيد المخزون غير صحيح.",
    addUser: 'إضافة مستخدم',
    isMenu: 'عرض في قائمة العملاء',
    menuSmart: 'إعداد قائمة المنتجات',
    smartSettingTitle: 'إعداد القائمة',
    smartSetting: 'إعداد القائمة لـ Silom CRM',
    confirmEnable: 'هل تريد تفعيل القائمة؟',
    confirmDisEnable: 'هل تريد تعطيل القائمة؟',
    confirmSelfOrderEnable: 'هل تريد تفعيل قائمة الطلب الذاتي؟',
    confirmSelfOrderDisable: 'هل تريد تعطيل قائمة الطلب الذاتي؟',
    enable: 'تفعيل',
    disable: 'تعطيل',
    usabilityStatus: 'مفعّل',
    manageSmartOnProduct: 'يمكنك "إضافة/تعديل" قائمة المنتجات المعروضة للعملاء في الصفحة.',
    manageSmartOnCategory: 'يمكنك "إضافة/تعديل" قائمة الفئات المعروضة للعملاء في الصفحة.',
    turnonSmart: 'وتفعيل القائمة',
    manageShopDes: 'يمكنك الرجوع إلى دليل المستخدم في -',
    desSmartMenu: 'إعداد قائمة المنتجات لعرض القائمة الإلكترونية على LINE ليتمكن العملاء من الوصول والطلب بسهولة.',
    link: 'رابط',
    createTranferOut: 'إنشاء مستند نقل صادر',
    roundingValue: 'تعديل التقريب',
    limitItems: 'يمكن اختيار حتى 200 منتج',
    IncomeCategory: 'الإيرادات',
    ExpenseCategory: 'المصروفات',
    saveBy: 'حُفظ بواسطة',
    saveDate: 'تاريخ الحفظ',
    drawerCate: 'الفئات',
    openingHours: 'ساعات العمل',
    shopLocation: 'موقع المتجر',
    sunday: 'الأحد',
    monday: 'الإثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الأربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    saturday: 'السبت',
    lat: 'خط العرض',
    lng: 'خط الطول',
    shopCoverSetting: 'إعداد غلاف المتجر',
    shopCoverSettingDes: 'إعداد غلاف المتجر للعرض على شاشة العميل',
    locationSettingDes: 'إعداد الموقع',
    updatelocation: 'تحديث الموقع',
    searchLocation: 'البحث عن موقع',
    imaginaryLine: 'خط وهمي',
    openingHoursDes: 'إعداد ساعات عمل المتجر',
    paymentDescriptionConfig: 'اختر طريقة الدفع',
    creditCard: 'بطاقة ائتمان',
    promptPay: 'Promptpay',
    coupon: 'قسيمة',
    quickpay: 'Krungsri Quick Pay',
    alipay: 'Alipay',
    linepay: 'Rabbit LINE Pay',
    thaidotcom: 'Thai Dot Com Payment',
    mounth: 'شهر',
    dayMY: 'التاريخ',
    item: 'عنصر',
    byStockIn: 'إدخال مخزون',
    stockOutOther: 'أخرى',
    drawerSales: 'المبيعات',
    sumIncomeExpenses: 'ملخص الإيرادات والمصروفات',
    incomeOther: 'إيرادات أخرى',
    loss: 'خسارة',
    grossProfit: 'الربح الإجمالي',
    newUser: 'مستخدم جديد',
    userType: 'نوع المستخدم',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    ParticipatingProducts: 'اختر المنتجات',
    descriptionSilomOrder: 'اختر المنتجات لـ order.silompos.com',
    cashierManagement: 'إدارة الكاشير',
    cashierManageButton: 'إدارة',
    cashierUsernamePassword: 'اسم المستخدم وكلمة المرور',
    cashierCRUDDescription: 'لتسجيل الدخول إلى order.silompos.com',
    password: 'كلمة المرور',
    placeholderPassword: 'أدخل كلمة المرور',
    resetPassword: 'إعادة تعيين كلمة المرور',
    oldPassword: 'كلمة المرور القديمة',
    oldPasswordPlaceholder: 'كلمة المرور القديمة',
    newPassword: 'كلمة المرور الجديدة',
    purchaseDetail: 'تفاصيل الشراء',
    uploadImage: 'رفع صورة',
    keyword: 'كلمة مفتاحية',
    firstname: 'الاسم الأول',
    lastname: 'اسم العائلة',
    province: 'المحافظة',
    district: 'المنطقة',
    subdistrict: 'الحي',
    addressNumber: 'العنوان',
    setAsDefaultAddress: 'تعيين كعنوان افتراضي',
    setAsTaxAddress: 'تعيين كعنوان ضريبي',
    setAsShippingAddress: 'تعيين كعنوان شحن',
    contact: 'الاتصال',
    setAsDefault: 'تعيين كافتراضي',
    addressLists: 'قائمة العناوين',
    default: 'افتراضي',
    taxAddress: 'فاتورة ضريبية',
    shippingAddress: 'الشحن',
    addAddress: 'إضافة',
    createdAt: 'تاريخ الإنشاء',
    updatedAt: 'تاريخ التحديث',
    by: 'بواسطة',
    readyForSale: 'جاهز للبيع',
    sold: 'مباع',
    delete: 'حذف',
    items: 'عناصر',
    itemDiscount: 'خصم العنصر',
    failedToSave: 'فشل الحفظ!',
    dateOfBirth: 'تاريخ الميلاد',
    menu: 'القائمة',
    dashboardMenu: 'لوحة المعلومات',
    transactionMenu: 'المعاملات',
    currentBillMenu: 'الفاتورة الحالية',
    reportMenu: 'التقارير',
    orderDeviceMenu: 'جهاز الطلب',
    memberMenu: 'الأعضاء',
    inventoryMenu: 'المخزون',
    productMenu: 'المنتجات',
    selfOrderMenu: 'قنوات البيع',
    settingMenu: 'الإعدادات',
    salesReportByDate: 'المبيعات حسب التاريخ',
    salesReportByBill: 'المبيعات حسب الفاتورة',
    salesQuantitySummaryByProductReport: 'المبيعات حسب المنتج',
    quantitySummaryByPLUReport: 'المبيعات حسب المنتج (PLU)',
    nonSellingProduct: 'المنتجات غير المباعة',
    salesSummaryByCashierReport: 'المبيعات حسب الكاشير',
    salesSummaryByCategoryReport: 'المبيعات حسب الفئة',
    paymentReport: 'الدفع',
    salesTaxReport: 'ضريبة المبيعات',
    drawerReport: 'الدرج',
    voidBillReport: 'الفواتير الملغاة',
    timesheetReport: 'جدول الدوام',
    stockInByListReport: 'إدخال المخزون حسب المنتج',
    stockOutByListReport: 'إخراج المخزون حسب المنتج',
    nonAdjustStockProductReport: 'منتجات مخزون غير معدلة',
    exportProductReport: 'تصدير المنتجات',
    salesSummaryByOrderReport: 'حسب جهاز الطلب',
    salesSummaryProductByOrderReport: 'حسب المنتج',
    voidBillByOrderReport: 'الفواتير الملغاة',
    inventoryReport: 'تقرير المخزون',
    inventoryReportByPLU: 'تقرير المخزون حسب PLU',
    inventoryReportBySerial: 'تقرير المخزون حسب Serial No.',
    stockMovement: 'حركة المخزون',
    stockInDocument: 'مستند إدخال المخزون',
    stockOutDocument: 'مستند إخراج المخزون',
    adjustStockDocument: 'مستند تعديل المخزون',
    selfOrder: 'طلب ذاتي',
    cashier: 'الكاشير',
    permission: 'الصلاحيات',
    menuSetting: 'إعداد القائمة',
    management: {
        txtManagement: 'الإدارة',
        user: 'الحساب',
        shopBranch: 'المتجر والفروع',
        productManagement: 'المنتجات',
        unitManagement: 'الوحدات',
        categorytManagement: 'الفئات',
        inventory: 'المخزون',
        stockIn: 'إدخال مخزون',
        stockOut: 'إخراج مخزون',
        adjustStock: 'تعديل المخزون',
        checkStock: 'فحص المخزون',
        stockMovement: 'حركة المخزون',
        transferStock: 'نقل المخزون',
        reportByPLU: 'تقرير المخزون حسب PLU',
        reportBySKU: 'تقرير المخزون',
        txtreportBySKU: 'تقرير المخزون',
        txtreportByPLU: 'تقرير المخزون حسب PLU',
        stockInDoc: 'مستند إدخال المخزون',
        stockOutDoc: 'مستند إخراج المخزون',
        adjustStockDoc: 'مستند تعديل المخزون',
        transferStockDoc: 'مستند نقل المخزون',
        transferStockInDoc: 'مستند نقل مخزون وارد',
        transferStockOutDoc: 'مستند نقل مخزون صادر',
    },
    report: {
        dashboard: 'لوحة المعلومات',
        transaction: 'المعاملات',
        currentbill: 'الفاتورة الحالية',
        daily: 'حسب التاريخ',
        txtdaily: 'تقرير المبيعات حسب التاريخ',
        dailyDes: 'تفاصيل تقرير المبيعات حسب التاريخ',
        sellbyProduct: 'حسب تفاصيل الفاتورة',
        txtsellbyProduct: 'تقرير المبيعات حسب تفاصيل الفاتورة',
        sku: 'حسب المنتج',
        txtsku: 'تقرير المبيعات حسب المنتج',
        plu: 'حسب المنتج (PLU)',
        textPlu: 'تقرير المبيعات حسب المنتج (PLU)',
        paymentreport: 'تقرير الدفع',
        txtpaymentreport: 'تقرير الدفع',
        timesheet: 'جدول الدوام',
        txtTimesheet: 'تقرير جدول الدوام',
        unsell: 'المنتجات غير المباعة',
        txtUnsell: 'المنتجات غير المباعة',
        byCategory: 'حسب الفئة',
        txtbyCategory: 'تقرير المبيعات حسب الفئة',
        byCashier: 'حسب الكاشير',
        txtbyCashier: 'تقرير المبيعات حسب الكاشير',
        salesTax: 'تقرير ضريبة المبيعات',
        txtSalesTax: 'تقرير ضريبة المبيعات',
        voidbill: 'الفواتير الملغاة',
        txtvoidbill: 'تقرير الفواتير الملغاة',
        closedSale: 'إغلاق المبيعات',
        txtCloseSale: 'تقرير الدرج',
        salesByOrder: 'ملخص المبيعات',
        productByOrder: 'حسب المنتج',
        unsalesByOrder: 'الفواتير الملغاة',
        txtDeliveryRoport: 'تقرير الدفع حسب التوصيل',
        txtCustomReport: 'تقرير الدفع المخصص',
        txtSalesByOrder: 'مبيعات المنتجات حسب جهاز الطلب',
        txtDailyOrder: 'تقرير المبيعات حسب جهاز الطلب',
        txtViodOrder: 'الفواتير الملغاة حسب جهاز الطلب',
        nonadjust: 'منتجات مخزون غير معدلة',
        txtnonadjust: 'تقرير منتجات مخزون غير معدلة',
        stockInReport: 'تقرير إدخال المخزون حسب المنتج',
        stockOutReport: 'تقرير إخراج المخزون حسب المنتج',
        stockIn: 'إدخال المخزون حسب المنتج',
        stockOut: 'إخراج المخزون حسب المنتج',
        exportProduct: 'تصدير المنتجات',
        txtExportProduct: 'تقرير تصدير المنتجات',
        cashDrawer: 'الدرج',
        txtCashDrawerr: 'تقرير إدارة النقد',
        cashRevenue: 'إيرادات النقد',
    },
    drawer: {
        cashDrawer: 'الدرج',
        txtCashDrawerr: 'تقرير إدارة النقد',
        cashRevenue: 'ملخص الإيرادات والمصروفات',
        txtcashRevenue: 'تقرير ملخص الإيرادات والمصروفات',
    },
    member: {
        txtmember: 'الأعضاء',
        register: 'تسجيل المتجر (LINE OA)',
        loyaltyPoint: 'نقاط الولاء',
        storeCredit: 'رصيد المتجر',
        deal: 'عرض',
        giftVoucher: 'قسيمة هدية',
        referral: 'دعوة',
        crm: 'Silom CRM',
    },
    unableStockDescription: 'لا يمكن تعديل المنتج بسبب تحديث المخزون بعد إنشاء المستند.',
    noItem: 'لا يوجد عنصر',
    enterProductName: 'أدخل اسم المنتج',
    ByCategory: 'حسب الفئة',
    ByCategoryDetail: 'تفاصيل حسب الفئة',
    maximum: 'الحد الأقصى',
    selectZone: 'اختر المنطقة',
    minimum: 'الحد الأدنى',
    unlimited: 'غير محدود',
    startTime: 'وقت البدء',
    endTime: 'وقت الانتهاء',

    "errorMessages": {
        "qrExpired": "انتهت صلاحية QR Code",
        "qrNotFound": "QR Code غير موجود",
        "paymentSuccess": "الدفع ناجح",
        "invalidQrType": "نوع QR Code غير صالح",
        "tableMoved": "تم نقل الطاولة",
        "receiptVoided": "تم إلغاء الإيصال"
    },
    "errorDescriptions": {
        "qrExpired": "QR Code الذي استخدمته قد انتهت صلاحيته.<br>يرجى التواصل مع موظفنا للمساعدة.",
        "qrNotFound": "لم يتم العثور على معلومات QR Code لطلب الطعام.<br>يرجى التواصل مع موظفنا.",
        "paymentSuccess": "شكراً لاستخدام خدمتنا!",
        "invalidQrType": "يرجى التواصل مع موظفنا للحصول على QR Code ديناميكي.",
        "tableMoved": "يرجى التواصل مع موظفنا للحصول على QR Code جديد.",
        "receiptVoided": "شكراً لاستخدام خدمتنا.<br>يرجى التواصل مع موظفنا إذا كنت بحاجة إلى مساعدة."
    },
    waitForServe: 'بانتظار التقديم',
    DineInPaymentDetails: 'الدفع',
    silomPayProDesp: 'دفع آمن بواسطة Silom Pay Easy',
    billDetail: 'تفاصيل الفاتورة',
    minute: 'دقائق',
    paymentTImeExpired: 'انتهى الوقت',
    openApp: 'افتح التطبيق',
    callPayStaffSuccess: 'تم استدعاء الموظف<br>يرجى الانتظار للمساعدة في إتمام الدفع',
    account: 'الحساب',
    refNumber: 'رقم المرجع',
    QRCodeBBL: 'QR Code بطاقة ائتمان',
    trackOrderStatus: 'تتبع حالة الطلب',
    all: 'الكل',
    noOrderThisStatus: 'لا توجد طلبات بهذه الحالة',
    orderCompleteThanks: 'شكراً لاستخدام خدمتنا!',
    OnPreparingYourOrder: 'جارٍ تحضير طلبك...',
    goToTracking: 'انتقل إلى صفحة التتبع',
    "dine-in": 'تناول الطعام في المكان',
    typeOfOrder: 'نوع الطلب',
    queue: 'الدور',
    cooking: 'قيد الطهي',
    orderedAt: 'تم الطلب في',
    orderTimeStatus: 'وقت الطلب',
    acceptTimeStatus: 'وقت القبول',
    estTimeStatus: 'الوقت المقدر',
    newOrderDelivery: 'طلب جديد',
    acceptOrderDelivery: 'قبول الطلب',
    readyToServeDelivery: 'جاهز للتقديم',
    orderCompleted: 'الطلب منتهي',
    orderCanceled: 'الطلب ملغى',
    readyToShip: 'جاهز للشحن',
    scanForPayment: 'امسح للدفع',
    orderType: 'نوع الطلب',
    welcomeBack: "مرحباً بعودتك 👋",
    welcomeBackDespt: "سجل الدخول لمتابعة طلب الطعام",
    orLoginWith: "أو سجل الدخول بـ",
    dontHaveAccount: 'ليس لديك حساب؟',
    register: 'تسجيل',
    fullName: "الاسم الكامل",
    fullNameDespt: 'اسمك الكامل',
    emailDespt: 'بريدك الإلكتروني',
    createPassword: 'إنشاء كلمة المرور',
    alreadyHaveAccount: 'لديك حساب بالفعل',
    verifyEmail: 'التحقق من البريد',
    enterOTPSentTo: 'أدخل OTP المرسل إلى',
    enterSixOTP: 'أدخل OTP المكون من 6 أرقام',
    verifyOTP: 'التحقق من OTP',
    weWillSentOTPEmail: 'سنرسل OTP إلى بريدك الإلكتروني',
    enterYourEmail: 'أدخل بريدك الإلكتروني',
    confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
    sendOTP: 'إرسال OTP',
    addPhoneNumber: 'إضافة رقم الهاتف',
    addPhoneForRegister: 'إضافة رقم الهاتف للتسجيل',
    enterPhone: 'أدخل رقم الهاتف',
    phoneUsed: 'رقم الهاتف مستخدم بالفعل',
    emailUsed: 'البريد الإلكتروني مستخدم بالفعل',
    enterPassword: 'أدخل كلمة المرور',
    registerEmail: 'البريد المسجل',
    otpInvalid6: "يرجى إدخال OTP صالح مكون من 6 أرقام.",
    emailVerified: "تم التحقق من البريد بنجاح!",
    emailOrPasswordInvalid: 'بريد إلكتروني أو كلمة مرور غير صالحة',
    pleaseEnterEmail: 'يرجى إدخال بريدك الإلكتروني',
    otpSentToEmail: "تم إرسال OTP إلى بريدك",
    passwordNotMatch: "كلمات المرور غير متطابقة",
    resetPasswordCompleted: 'تم إعادة تعيين كلمة المرور بنجاح!',
    failResetPassword: 'فشل إعادة تعيين كلمة المرور',
    completePhoneFail: 'فشل تسجيل الهاتف',
    plaseEnterValidEmail: 'يرجى إدخال عنوان بريد إلكتروني صالح',
    invalidPhoneNumber: 'الهاتف يجب أن يبدأ بـ 06 أو 08 أو 09 ويحتوي على 10 أرقام',
    example: 'مثال',
    passwordSet: "أكثر من 6 أحرف ويجب أن تتضمن رقماً",
    SelectTableToAdd: 'الطاولة',
    availableTable: 'متاح',
    unAvailableTable: 'غير متاح',
    SelectTableToAddDesp: 'اختر طاولة لتناول الطعام<br>ملاحظة: إذا كنت ترغب في تغيير الطاولة، يرجى التواصل مع الموظف',
    updatedStaus: 'تم تحديث الحالة',
    otpExpired: 'انتهت صلاحية OTP',
    and: "و",
    emailOTP: "OTP البريد الإلكتروني",
    emailOTPDesp: "أدخل OTP المستلم عبر البريد",
    phoneOTP: "OTP الهاتف",
    phoneOTPDesp: "أدخل OTP المستلم عبر SMS",
    checkSpamBox: '* إذا لم تستلم البريد، يرجى التحقق من مجلد البريد العشوائي. قد يستغرق الأمر بضع دقائق.',
    DineInPaymentPending: 'الدفع معلق',
    visitProceedPayment: 'انتقل إلى الدفع',
    proceedPayment: "متابعة الدفع",
    proceedPaymentDesp: "هذه الفاتورة قيد معالجة الدفع حالياً.<br>إذا كنت ترغب في طلب المزيد،<br>يرجى إلغاء الدفع الجاري أولاً",
    queueIndex: 'الدور',
    otpSentToPhone: 'تم إرسال OTP عبر SMS.',
    failToSendOTP: 'فشل إرسال OTP',
    somethingWentWrong: 'حدث خطأ ما',
    tableHasNoOrder: 'لا يوجد طلب على الطاولة',
    kbankProceedPaymentDesp: 'هذه الفاتورة قيد معالجة الدفع حالياً.<br>إذا كنت ترغب في إضافة المزيد أو تغيير طريقة الدفع،<br>يرجى إلغاء الدفع الجاري أولاً'
,
  openHours: 'مفتوح',
}

export default messages
